console.log("=== SCRIPT FILE EXECUTED ===");
console.log("Document ready state:", document.readyState);

document.addEventListener("DOMContentLoaded", function () {
  console.log("Page loaded");
// Scroll to complete the look section
  document.querySelector('.look-grid')?.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector('.complete-look-section')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });

// Hide nav on scroll
  function throttle(func, limit) {
    let inThrottle;
    return function (...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  }

  let lastScrollTop = 0;
  const navBar = document.querySelector(".header-section");

  window.addEventListener(
    "scroll",
    throttle(() => {
        const scrollTop = window.scrollY;

        if (scrollTop < 60) {
          navBar.style.transform = "translateY(0)";
          return;
        }

        if (scrollTop >= lastScrollTop) {
          navBar.style.transform = "translateY(-200%)";
        } else {
          navBar.style.transform = "translateY(0)";
        }

        lastScrollTop = scrollTop;
      }, 100),
  );

// size chart toggle
    const options = document.querySelectorAll('.switcher_option');
    const slider = document.querySelector('.switcher_slider');
    const tableCells = document.querySelectorAll('.size-chart tbody td');
    const chartTrigger = document.querySelector('.size-guide-trigger');
    const modalCloses = document.querySelectorAll('.close-modal');

    if(chartTrigger){
      const chartModal = document.querySelector('.size-chart-modal');
      console.log("MODAL FOUND")
      chartTrigger.addEventListener('click', function (e) {
        console.log("FIRED BUTTON");
        e.preventDefault();
        e.stopPropagation();
        chartModal?.classList.add('is-open');
        document.documentElement.setAttribute('scroll-lock', '');

      });


      modalCloses.forEach(btn => {
        btn.addEventListener('click', function(e){
          e.preventDefault();
          chartModal?.classList.remove('is-open');
          document.documentElement.removeAttribute('scroll-lock');
        })
      })
    } else {
      console.log("no modal found");
    }

    const originalValues = Array.from(tableCells).map(cell => {
      const text = cell.textContent.trim();
      const isNumeric = /^\d+(\.\d+)?$/.test(text);
      return isNumeric ? parseFloat(text) : null;
    });

    options.forEach(option => {
      option.addEventListener('click', function() {
        const unit = this.dataset.unit;
        let isInches
        if(unit == 'sizeGuide-in-select') {
          isInches = true
        } else {
          isInches = false
        }

        options.forEach(opt => {
          opt.classList.remove('switcher_option--active');
          opt.setAttribute('aria-current', 'false');
        });
        this.classList.add('switcher_option--active');
        this.setAttribute('aria-current', 'true');

        if (isInches) {
          slider.style.left = '0%';
        } else {
          slider.style.left = '50%';
        }

        tableCells.forEach((cell, index) => {
          const originalValue = originalValues[index];

          if (originalValue === null) {
            return;
          }

          if (isInches) {
            const inches = (originalValue / 2.54).toFixed(1);
            const rounded = Math.round(inches * 2) / 2;
            cell.textContent = rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1);
          } else {
            cell.textContent = originalValue;
          }
        });
      });
    });

    document.querySelectorAll('[data-accordion-trigger]').forEach(trigger => {
      const slideId = trigger.getAttribute('data-accordion-trigger');
      const modal = document.querySelector(`[data-accordion-slide="${slideId}"]`);

      if (!modal) return;

      trigger.addEventListener('click', e => {
        e.preventDefault();
        modal.classList.add('is-open');
        document.documentElement.setAttribute('scroll-lock', '');
      });

      modal.querySelectorAll('.close-modal').forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          modal.classList.remove('is-open');
          document.documentElement.removeAttribute('scroll-lock');
        });
      });
    });

// Loyalty Slider
    const sliderEl = document.querySelector(".loyalty-slider");

    if(sliderEl){
      const loyalySlider = new BlazeSlider(sliderEl, {
        all: {
          enableAutoplay: true,
          slidesToShow: 1,
          transitionDuration: 700,
          loop: true
        },
      });
    }

// Benefits accordion
    const benefits = document.querySelectorAll('.benefits-accordion');

    benefits.forEach(benefit => {
      const header = benefit.querySelector('.accordion-header');

      header?.addEventListener('click', () => {
        benefit.classList.toggle('open');
      });
    });

// Get the look modal
const getLookBtns = document.querySelectorAll('.get-the-look-badge');
const lookModal = document.querySelector('.get-the-look-modal');
const modalProducts = lookModal?.querySelector('.get-the-look-products');

if (getLookBtns.length) {
  if (!lookModal) return;

  getLookBtns.forEach(getLookBtn => {
    getLookBtn.addEventListener('click', function () {
      lookModal.classList.add('is-open');
      document.documentElement.setAttribute('scroll-lock', '');

      const productsData = getLookBtn.dataset.products;

      if (!productsData) return;

      let productHandles;
      try {
        productHandles = JSON.parse(productsData);
      } catch {
        console.error('Invalid metafield JSON in data-products:', productsData);
        return;
      }

      // Fetch both HTML and JSON for each product
      Promise.all(
        productHandles.map(handle =>
          Promise.all([
            fetch(`/products/${handle}`).then(res => res.text()),
            fetch(`/products/${handle}.js`).then(res => res.json())
          ]).then(([html, json]) => ({ html, json }))
        )
      ).then(products => {
        modalProducts.innerHTML = '';

        products.forEach(({ html, json }) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const variantPicker = doc.querySelector('variant-picker');
          const productForm = variantPicker?.querySelector('form');
          const productTitle = doc.querySelector('.product-title, h1')?.textContent.trim() || json.title;
          const productUrl = json.url;
          const productImage = json.featured_image;

          // Get the initial variant (first available or first variant)
          const initialVariant = json.variants.find(v => v.available) || json.variants[0];

          if (!productForm) return;

          const container = document.createElement('div');
          container.classList.add('get-look-item');

          container.innerHTML = `
            ${productImage ? `<img src="${productImage}" alt="${productTitle}" class="get-look-image">` : ''}
            <div class="get-look-info">
              <h3><a href="${productUrl}">${productTitle}</a></h3>
              <div class="product-price">
                <span class="price">£${(initialVariant.price / 100).toFixed(2)}</span>
              </div>
            </div>
          `;

          // Clone and append the actual product form
          const clonedForm = productForm.cloneNode(true);
          clonedForm.classList.add('product-form');

          // Ensure the form has a hidden input for variant ID
          let variantIdInput = clonedForm.querySelector('input[name="id"]');
          if (!variantIdInput) {
            variantIdInput = document.createElement('input');
            variantIdInput.type = 'hidden';
            variantIdInput.name = 'id';
            clonedForm.appendChild(variantIdInput);
          }
          variantIdInput.value = initialVariant.id;

          // Add the submit button
          const submitButton = document.createElement('button');
          submitButton.type = 'submit';
          submitButton.className = 'button button--primary';
          submitButton.textContent = 'Add to Cart';
          clonedForm.appendChild(submitButton);

          container.querySelector('.get-look-info').appendChild(clonedForm);
          modalProducts.appendChild(container);

          // Handle variant selection for price updates
          const priceElement = container.querySelector('.price');
          const radioInputs = clonedForm.querySelectorAll('input[type="radio"]');

          radioInputs.forEach(input => {
            input.addEventListener('change', () => {
              // Get all selected option values
              const selectedOptions = [];
              clonedForm.querySelectorAll('fieldset').forEach(fieldset => {
                const selected = fieldset.querySelector('input[type="radio"]:checked');
                if (selected) {
                  selectedOptions.push(selected.value);
                }
              });

              // Find matching variant
              const matchingVariant = json.variants.find(variant => {
                return variant.options.every((opt, i) => opt === selectedOptions[i]);
              });

              if (matchingVariant) {
                // Update price
                priceElement.textContent = `£${(matchingVariant.price / 100).toFixed(2)}`;

                // Update hidden variant ID
                variantIdInput.value = matchingVariant.id;

                // Update button state based on availability
                submitButton.disabled = !matchingVariant.available;
                submitButton.textContent = matchingVariant.available ? 'Add to Cart' : 'Out of Stock';
              }
            });
          });
        });

        // Add to cart functionality
        modalProducts.querySelectorAll('.product-form').forEach(form => {
          form.addEventListener('submit', async e => {
            e.preventDefault();
            const button = form.querySelector('button[type="submit"]');
            const originalText = button.textContent;

            button.disabled = true;
            button.textContent = 'Adding...';

            const formData = new FormData(form);

            try {
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
              });

              const data = await response.json();

              if (!response.ok) {
                throw new Error('Failed to add to cart');
              }

              // Fetch updated cart state
              const cartResponse = await fetch('/cart.js');
              const cartData = await cartResponse.json();

              // Dispatch event
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  data: {
                    didError: false,
                    item: data,
                    cart: cartData
                  }
                }
              }));

              button.textContent = 'Added!';
              setTimeout(() => {
                button.textContent = originalText;
                button.disabled = false;
              }, 2000);

            } catch (err) {
              console.error('Error adding to cart:', err);
              button.textContent = 'Error';
              setTimeout(() => {
                button.textContent = originalText;
                button.disabled = false;
              }, 2000);
            }
          });
        });

        // Close modal handlers
        lookModal.querySelectorAll('.close-modal').forEach(btn => {
          btn.addEventListener('click', e => {
            e.preventDefault();
            lookModal.classList.remove('is-open');
            document.documentElement.removeAttribute('scroll-lock');
            modalProducts.innerHTML = '';
          });
        });
      });
    });
  });
}
//Collection mobile toggle
const gridControls = document.querySelector('.grid-controls');
const gridButtons = document.querySelectorAll('.grid-toggle');
const productGrid = document.querySelector('.product-grid');

gridButtons.forEach(toggle => {
  toggle.addEventListener('click', () => {

    gridButtons.forEach(b => b.classList.remove('active'));
    toggle.classList.add('active');

    if (toggle.classList.contains('grid-toggle-single')) {
      gridControls?.classList.add('single');
      productGrid?.classList.remove('product-grid-split');
    } else {
      gridControls?.classList.remove('single');
      productGrid?.classList.add('product-grid-split');
    }
  });
});

});
